import strings from 'owa-strings/owa-options-strings';
export default function getInboxRuleMessageFlagOptions() {
    return [
        { value: 'Any', text: strings.options_inboxRules_any },
        { value: 'Call', text: strings.options_inboxRules_call },
        { value: 'DoNotForward', text: strings.options_inboxRules_doNotForward },
        { value: 'FollowUp', text: strings.options_inboxRules_followUp },
        { value: 'Forward', text: strings.options_inboxRules_forward },
        { value: 'ForYourInformation', text: strings.options_inboxRules_forYourInformation },
        { value: 'NoResponseNecessary', text: strings.options_inboxRules_noResponseNecessary },
        { value: 'Read', text: strings.options_inboxRules_read },
        { value: 'Reply', text: strings.options_inboxRules_reply },
        { value: 'ReplyToAll', text: strings.options_inboxRules_replyToAll },
        { value: 'Review', text: strings.options_inboxRules_review },
    ];
}
//# sourceMappingURL=getInboxRuleMessageFlagOptions.js.map